export const CO_PARENT_EVENTS = {
  VIEW_CO_PARENTING_LINK_OPEN: 'view_co_parenting_link_open',
  SELECT_CO_PARENTING_ACCEPT_INVITE: 'select_co_parenting_accept_invite',
} as const;
